import { createRootRouteWithContext, Outlet } from '@tanstack/react-router'
import { Suspense } from 'react'

import { Loading } from 'components/Loading'
import { ViewAsBanner } from 'components/ViewAsBanner'

import { useTracking } from 'hooks/useTracking'

import NotFound from 'pages/NotFound'

import type { RouterContext } from '../router'

export function RootComponent() {
  useTracking()

  return (
    <Suspense fallback={<Loading />}>
      <Outlet />
      {/* Root-level so it shows on Home, /mapping, /terms etc., once. */}
      <ViewAsBanner />
    </Suspense>
  )
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
  notFoundComponent: () => (
    <Suspense fallback={<Loading />}>
      <NotFound />
    </Suspense>
  ),
})
